import { Done } from "@mui/icons-material";
import { Cancel } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { FC, useMemo } from "react";
import { formatSchedulerTime } from "../DispatchesHelper";

export const ManagementEventBar: FC<any> = (props: { key: any, eventRecord: any, resourceRecord: any }) => {
    const { startDate, endDate, data } = props.eventRecord;

    const equipment = useMemo(() => {
        return data?.equipment ? `(${data?.equipment?.equipmentType?.type ?? ''} #${data?.equipment?.number ?? ''})` : '';
    }, [data?.equipment]);

    const intervalInfo = useMemo(() => {
        if (!data?.dispatchingIntervalTime) {
            return '';
        }
        const intervalCount = data?.dispatchingIntervalCount ?? data?.orderLineItem?.intervalCount ?? 0;
        const equipmentType = data?.orderLineItem?.equipmentTypeType ?? data?.equipment?.equipmentType?.type ?? '';
        const intervalTimeMinutes = data.dispatchingIntervalTime;
        
        if (intervalTimeMinutes) {
            return ` | ${intervalCount} ${equipmentType} every ${intervalTimeMinutes} min.`;
        }
        return '';
    }, [data?.dispatchingIntervalTime, data?.dispatchingIntervalCount, data?.orderLineItem?.intervalCount, data?.orderLineItem?.equipmentTypeType, data?.equipment?.equipmentType?.type]);

    const line1 = useMemo(() => {
        const baseLine = `${data?.name} ${equipment}`;
        return `${baseLine}${intervalInfo ?? ''}`;
    }, [data?.name, equipment, intervalInfo]);

    const line2 = useMemo(() => {
        return `${data?.description} (LI #${data?.orderLineItemNumber}, Order #${data?.orderNumber}, Job #${data?.jobNumber ?? '???'})`;
    }, [data?.description, data?.orderLineItemNumber, data?.orderNumber, data?.jobNumber]);

    const isCompleted = useMemo(() => {
        return data.isCompleted;
    }, [data.isCompleted])

    const isCanceled = useMemo(() => {
        const hasCanceledValue = data.canceledOn != null;
        return hasCanceledValue;
    }, [data.canceledOn])

    const eventBar = useMemo(() => {
        return (
            <div className="management-event-bar" style={{ width: '100%', minWidth: 0 }}>
                <Grid item container spacing={1} alignItems='center' wrap='nowrap' sx={{ width: '100%', minWidth: 0 }}>
                    {isCompleted && <Grid item xs={2}>
                        <Done />
                    </Grid>}
                    {isCanceled && <Grid item xs={2}>
                        <Cancel />
                    </Grid>}
                    <Grid item container direction='column' xs={isCompleted || isCanceled ? 10 : 12} sx={{ minWidth: 0, flex: 1 }}>
                        <Grid item container alignItems='center' justifyContent='space-between'>
                            <Grid item>
                                <span>
                                    {line1}
                                </span>
                            </Grid>
                            <Grid item>
                                <span style={{ marginLeft: '8px' }}>{formatSchedulerTime(startDate)} - {formatSchedulerTime(endDate)}</span>
                            </Grid>
                        </Grid>
                        {line2 && <Grid item>
                            <span>{line2}</span>
                        </Grid>}
                    </Grid>
                </Grid>
            </div>
        );
    }, [endDate, isCanceled, isCompleted, line1, line2, startDate]);

    return (
        <>{eventBar}</>
    );
};